import React from 'react';

/**
 * Buy Me a Coffee button component
 * Used in both desktop and mobile footer layouts
 */
export default function BuyMeACoffeeButton({ 
  className = '', 
  theme = 'dark'
}) {
  const buttonImage = theme === 'light' 
    ? '/bmc-button-white.png' 
    : '/bmc-button-black.png';
  
  return (
    <a 
      href="https://buymeacoffee.com/lutherstudio" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`bmc-custom-btn ${className}`}
    >
      <img src={buttonImage} alt="Buy me a coffee" className="bmc-button-image" />
    </a>
  );
}

